module.exports = __webpack_public_path__ + "img/home_icon_dabache_default.03f39949.png";